// extracted by mini-css-extract-plugin
module.exports = {"container":"Loading_container__3DxKb","glimmer":"Loading_glimmer__14Tmq","full":"Loading_full__3G5yl","small":"Loading_small__lYmJt","tiny":"Loading_tiny__3oUVz"};